import React from 'react'

import { FormWarningAlert } from 'components/reusables/formWarningAlert'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from './common'

export const NormativeCourseEditRetroactiveAlert: React.FC = () => {
  const t = useTranslationRankmi({
    prefix: `${prefix}.normative.editRetroactiveDc3Alert`,
  })

  return <FormWarningAlert message={t('message')} />
}
